<template>
    <div>
        <!-- Офис -->
        <div v-if="sended && sendedSuccess && !isDelivery" class="form__scope _dflex _justify-content-between _flexwrap-mobile">
            <div class="_w-488 _mb-0-24">
                <h2 class="h2 _mb-24">Ваша заявка на оформление карты принята</h2>
                <div v-if="!isDelivery" class="p1">Уже ждем вас в офисе банка для выдачи карты. Не забудьте паспорт</div>
            </div>

            <div class="_w-584">
                <div :class="{'_bg-white': !isMobile, '_p-40': !isMobile, '_br-40': !isMobile}">
                    <div :class="{'_w-100': isMobile}">
                        <div class="p1 text-gray">Адрес офиса банка</div>
                        <div class="p1 _mt-4 _mb-24">{{ officeAddress }}</div>
                    </div>

                    <div class="_divider _mb-24"></div>

                    <div v-if="!isDelivery" :class="{'_w-100': isMobile}">
                        <div class="p1 text-gray">Режим работы</div>
                        <div class="p1 _mt-4">{{ officeShedule }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- доставка неперсонка (МБ) -->
        <div v-if="sended && sendedSuccess && isDelivery && deliveryType === EAppointmentDeliveryType.MB" class="form__scope _dflex _justify-content-between _flexwrap-mobile">
            <div class="_w-488 _mb-0-24">
                <h2 class="h2 _mb-24">Ваша заявка на оформление карты принята</h2>
                <div class="p1">Наш сотрудник свяжется с вами в день встречи для уточнения условий доставки</div>
            </div>

            <div class="_w-584">
                <div :class="{'_bg-white': !isMobile, '_p-40': !isMobile, '_br-40': !isMobile}">
                    <div class="_dflex _flexwrap-mobile _justify-content-between">
                        <div class="_w-240" :class="{'_w-100': isMobile}">
                            <div class="p1 text-gray">Дата</div>
                            <div class="h2 _mb-24">{{ date }}</div>
                        </div>
                        <div class="_w-240" :class="{'_w-100': isMobile}">
                            <div class="p1 text-gray">Время</div>
                            <div class="h2 _mb-24">{{ prettyTime }}</div>
                        </div>
                    </div>

                    <div class="_divider _mb-24"></div>

                    <div :class="{'_w-100': isMobile}">
                        <div class="p1 text-gray">Адрес получения</div>
                        <div class="p1 _mt-4 _mb-24">{{ meetingAddress }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- доставка персонка (курьер) -->
        <div v-if="sended && sendedSuccess && isDelivery && deliveryType === EAppointmentDeliveryType.COURIER" class="form__scope _dflex _justify-content-between _flexwrap-mobile">
            <div class="_w-488 _mb-0-24">
                <h2 class="h2 _mb-24">Ваша заявка на оформление карты принята</h2>
                <div class="p1">Вы получите СМС с выбором даты и времени доставки</div>
            </div>

            <div class="_w-584">
                <div :class="{'_bg-white': !isMobile, '_p-40': !isMobile, '_br-40': !isMobile}">
                    <div :class="{'_w-100': isMobile}">
                        <div class="p1 text-gray">Адрес доставки</div>
                        <div class="p1 _mt-4 _mb-24">{{ meetingAddress }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import { EAppointmentDeliveryType } from '../widgets/MeetingForm/const';

    export default {
        name: "CardsFormV2Success",
        props: {
            sended: {
                type: Boolean,
                default: false
            },
            sendedSuccess: {
                type: Boolean,
                default: false
            },
            isDelivery: {
                type: Boolean,
                default: false
            },
            isPerson: {
                type: Boolean,
                default: false
            },
            isMobile: {
                type: Boolean,
                default: false
            },
            address: {
                type: String,
                default: ''
            },
            date: {
                type: String,
                default: ''
            },
            time: {
                type: String,
                default: ''
            },
            email: {
                type: String,
                default: ''
            },
            deliveryType: {
                type: String,
                default: ''
            },
            meetingAddress: {
                type: String,
                default: ''
            },
            officeAddress: {
                type: String,
                default: ''
            },
            officeShedule: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                EAppointmentDeliveryType,
            };
        },
        computed: {
            prettyDate() {
                dayjs.locale('ru')
                return dayjs(this.convertDateToEng(this.$props.date)).format('DD MMMM');
            },
            prettyTime() {
                if (!this.time) return 'Время не указано';
                return this.time.replace(/^(\d\d:\d\d).*-(\d\d:\d\d).*/, '$1-$2');
            },
        },
        methods: {
            convertDateToEng(val) {
                return val.replace(/\./g, '-').split('-').reverse().join('-');
            },
            sendStep(val, step) {
                this.$emit('sendStep', val, step)
            }
        }
    }
</script>
